require("!!C:\\Users\\dafre\\WebstormProjects\\climate2\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\dafre\\WebstormProjects\\climate2\\node_modules\\raw-loader\\index.js!C:\\Users\\dafre\\WebstormProjects\\climate2\\node_modules\\hammerjs\\hammer.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/hammerjs/hammer.js
// module id = 234
// module chunks = 3